import { useFeatureFlag } from '@/features/feature-flags/useFeatureFlag'
import { useFeatureFlagStore } from '@/features/feature-flags/useFeatureFlagStore'

// Preserve existing training for users outside the production preview.
export default function RhymeRollout({ legacy, children }) {
  const loading = useFeatureFlagStore((s) => s.loading)
  const enabled = useFeatureFlag('training.rhyme-lab')
  if (loading) return null
  return enabled ? children : legacy
}
